<!-- main app container -->
<div class="app-container">
  <div class="body">
    <alert></alert>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
